
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcDateItem as ObcDateItemElement} from '@oicl/openbridge-webcomponents/dist/components/date-item/date-item.js';
 import {DateItemEvent} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
 export type {DateItemEvent} from '@oicl/openbridge-webcomponents/dist/components/event-item/event-item.js';
 

 
 export const ObcDateItem = createComponent({
   react: React,
   tagName: 'obc-date-item',
   elementClass: ObcDateItemElement,
   events: {
     
     onDateClick: 'date-click' as EventName<CustomEvent<{date: number, events: DateItemEvent[], isToday: boolean, checked: boolean}>>,
   }
  });
 
 